<template>
  <PageView class="full-page" :no-sub-title-expected="true">
    <TitleView>{{ $t("registerPage.titre") }}</TitleView>

    <ContentView>
      <div v-if="isLoading">
        <b-skeleton width="40%" animated></b-skeleton>
        <b-skeleton width="80%" animated></b-skeleton>
      </div>
      <div v-else>
        <div v-if="!internalErrorMessage">
          <b-message type="is-success"> {{ registrationMessage }}</b-message>
        </div>
        <div v-if="internalErrorMessage">
          <b-message type="is-danger"> {{ internalErrorMessage }}</b-message>
        </div>
        <br />
        <b-message v-if="!internalErrorMessage || initialResendMode !== 'none'" type="is-warning">
          {{ $t("registerPage.checkspams") }}
        </b-message>

        <br />
        <b-button
          v-if="initialResendMode != 'none'"
          type="is-primary"
          @click="resendValidationEmail()"
        >
          {{ $t("registerPage.resend") }}
        </b-button>
      </div>
    </ContentView>
  </PageView>
</template>

<script lang="ts">
import { BButton, BMessage, BSkeleton } from "buefy"

import { defineComponent } from "vue"
import TitleView from "@/views/commons/TitleView.vue"
import ContentView from "@/views/commons/ContentView.vue"
import PageView from "@/views/commons/PageView.vue"
import { LoginService } from "@/services/rest/login/LoginService"

export default defineComponent({
  name: "RegisterPendingPage",
  components: {
    TitleView,
    ContentView,
    PageView,
    BButton,
    BMessage,
    BSkeleton,
  },
  data() {
    return {
      isLoading: false,
      internalErrorMessage: "",
      errorMessage: "",
      registrationMessage: "",
      mail: "",
      initialResendMode: "none",
    }
  },
  mounted(): void {
    const state = history.state as any
    this.errorMessage = (state?.errorMessage as string) || ""
    this.registrationMessage = (state?.registrationMessage as string) || ""
    this.mail = (state?.mail as string) || ""
    this.initialResendMode = (state?.initialResendMode as string) || "none"
    this.internalErrorMessage = this.errorMessage
    if (!this.registrationMessage) {
      this.$router.push("/login")
    }
  },
  methods: {
    async resendValidationEmail(): Promise<void> {
      try {
        this.isLoading = true
        this.internalErrorMessage = ""
        await LoginService.INSTANCE.resendValidationEMail(this.mail)
        this.isLoading = false
      } catch (e: any) {
        this.isLoading = false
        this.internalErrorMessage = this.$t("registerPage.resent-failure").toString()
      }
    },
  },
})
</script>
